export enum DateFormat {
  LONG = 'long',
  SHORT = 'short',
}

type ConvertDate = {
  date: Date;
  format: DateFormat;
  addDays?: number;
  subtractDays?: number;
};

export function convertDate({
  date = new Date(),
  format = DateFormat.SHORT,
  addDays = 0,
  subtractDays = 0,
}: ConvertDate): string {
  date.setDate(date.getDate() + addDays);
  date.setDate(date.getDate() - subtractDays);

  switch (format) {
    case DateFormat.SHORT: {
      return date.toLocaleString();
    }
    case DateFormat.LONG: {
      const formatted = date.toLocaleDateString('en-US', {
        month: 'long',
        day: 'numeric',
      });
      const year = date.getFullYear();
      return `${formatted}, ${year}`;
    }
    default:
      break;
  }

  return date.toISOString(); // Example implementation
}
